import { io } from 'socket.io-client';

const rawURL = process.env.REACT_APP_PROD_AUTH_URL || '';
const baseURL = rawURL.replace(/\/api\/?$/, '');

const socket = io(baseURL, {
  transports: ['websocket'],
});

export default socket;
